import { useContext, useRef } from "react"
import { CursorContext } from "./CursorContext"

let uid = 0
const nextId = () => `cz-${++uid}`

export function useCursor() {
  const ctx = useContext(CursorContext)
  const idsRef = useRef([])     // stable id per call-site, indexed by call order
  const callIndexRef = useRef(0)
  callIndexRef.current = 0      // useCursor() runs once per render → safe reset point

  const cursor = (config) => {
    const i = callIndexRef.current++
    if (idsRef.current[i] == null) idsRef.current[i] = nextId()
    const id = idsRef.current[i]

    return {
      onMouseEnter: () => ctx.push(id, config),
      onMouseLeave: () => ctx.pop(id),
    }
  }

  return { cursor }
}